@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.drivergroups
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.drivergroups.DriverGroupDto

object GetDriverGroupsByDriverEndpoint : EndPoint<GetDriverGroupsByDriverEndpoint.Request, GetDriverGroupsByDriverEndpoint.Response>() {
    class Request(
        val driverId: KmmLong,
    )

    class Response(
        val list: Array<DriverGroupDto>,
    )
}